import { Text, Tooltip } from '@mantine/core';

const SKIP_LABELS = {
  cookieLoss: 'cookie loss',
  noEngagementSignal: 'no engagement data',
  failed: 'run failed',
  notClassified: 'not classified',
};

const percent = (share) => `${Math.round(share * 100)}%`;

const hasShare = (share) => share !== null && share !== undefined;

export const skipExplanation = ({ reason, internalReferrerShare, chainedToOtherProfileShare }) => {
  if (reason === 'cookieLoss') {
    const measurements = [];
    if (hasShare(internalReferrerShare)) {
      measurements.push(`${percent(internalReferrerShare)} of single visits arrived from the site's own pages`);
    }
    if (hasShare(chainedToOtherProfileShare)) {
      measurements.push(
        `${percent(chainedToOtherProfileShare)} of back-to-back page views from one address switched profile`
      );
    }
    const detail = measurements.length > 0 ? ` (${measurements.join(', ')})` : '';
    return `The nightly bot check skipped this domain: the site seems to lose our cookie or not track every page view${detail}. Its MAU stays unadjusted.`;
  }
  if (reason === 'noEngagementSignal') {
    return 'The nightly bot check skipped this domain: the site sends no engagement events, so bots and visitors cannot be told apart. Its MAU stays unadjusted.';
  }
  if (reason === 'failed') {
    return 'The nightly bot check failed for this domain on its last run. Its MAU stays unadjusted.';
  }
  if (reason === 'notClassified') {
    return 'The nightly bot check did not classify this domain in the 2 days before the end of the selected period. Its MAU stays unadjusted.';
  }
  return 'The nightly bot check skipped this domain. Its MAU stays unadjusted.';
};

const BotClassificationNotMeasured = ({ classification }) => {
  const label = SKIP_LABELS[classification.reason];
  return (
    <Tooltip label={skipExplanation(classification)} multiline w={320} withArrow>
      <Text span size="xs" c="dimmed">
        {label ? `Not measured (${label})` : 'Not measured'}
      </Text>
    </Tooltip>
  );
};

export default BotClassificationNotMeasured;
